import picker_range_trigger_vue_vue_type_script_setup_true_lang_default from "./picker-range-trigger.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/time-picker/src/common/picker-range-trigger.vue
var picker_range_trigger_default = picker_range_trigger_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { picker_range_trigger_default as default };
//# sourceMappingURL=picker-range-trigger.mjs.map